import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { useAssistantPulseQuery } from '@/hooks/useAssistantProactive';
import { useAssistantPanel } from './assistantPanelContext';

export function AssistantBriefButton() {
  const { t } = useTranslation('assistant');
  const { requestBrief } = useAssistantPanel();
  const pulseQuery = useAssistantPulseQuery();
  const pulse = pulseQuery.data;
  if (pulse === undefined || pulse.isActive === false) {
    return null;
  }
  const briefKind = pulse.brief.kind;
  if (briefKind === null || pulse.brief.status === 'hidden') {
    return null;
  }
  const labelKey =
    pulse.brief.status === 'ready'
      ? 'brief.chip.' + briefKind + 'Ready'
      : 'brief.chip.' + briefKind;
  return (
    <button
      type="button"
      onClick={function openBrief() {
        requestBrief(briefKind);
      }}
      className="w-full mt-5 text-left px-4 py-3 rounded-xl bg-zoovpalelavender border border-zooprimary/30 text-sm font-semibold text-zooindigo hover:border-zooprimary transition-colors flex items-center gap-3"
    >
      <Icon name={briefKind === 'morning' ? 'Sun' : 'Moon'} className="text-zooprimary shrink-0" />
      <span className="flex-1">{t(labelKey)}</span>
      <Icon name="ArrowRight" className="text-zooprimary shrink-0" />
    </button>
  );
}
